var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBonuses = function SvgBonuses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.98,
    cy: 9,
    r: 9,
    fill: "#14642E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.98,
    cy: 15,
    r: 9.7,
    fill: "#3DC869",
    stroke: "#F8F8FD",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.806 15.304c.202-1.08.416-2.107.629-3.003L7.202 9.992c-.047 1.122.288 3.355.452 4.36q.6.446 1.152.952M10.96 17.751a20.5 20.5 0 0 1 1.908-2.018c-.19-1.794-1.328-5.402-1.92-6.733-.728 1.591-1.336 4.52-1.735 6.691.644.632 1.23 1.321 1.748 2.06M8.81 15.95c-.904-.964-3.012-2.349-3.83-2.647.955 4.441 2.738 6.28 4.137 7.038.462-.77.975-1.51 1.534-2.212a14.5 14.5 0 0 0-1.842-2.18M14.444 14.417c.216-1.293.289-3.266.317-4.345l-2.163 2.262q.435 1.491.687 3.024c.378-.333.768-.648 1.16-.94M14.817 14.725a20.7 20.7 0 0 0-5.276 5.818 3.9 3.9 0 0 0 1.919.328c3.944-.567 5.223-5.905 5.52-7.526q-1.131.611-2.163 1.38"
  })));
};
export default SvgBonuses;